import { render, staticRenderFns } from "./VisitsReport.vue?vue&type=template&id=1ca94682&"
import script from "./VisitsReport.vue?vue&type=script&lang=js&"
export * from "./VisitsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports